import { Component, OnInit, Output, EventEmitter, Inject, DOCUMENT } from "@angular/core";
import { Router, RouterLink } from "@angular/router";
import { CommonModule, NgOptimizedImage } from "@angular/common";
import { environment } from "../../../environments/environment";
import { CookieService } from "ngx-cookie-service";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { Store } from "@ngrx/store";
import { Observable, map } from "rxjs";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { SimplebarAngularModule } from "simplebar-angular";
import { AuthenticationService } from "../../core/services/authentication.service";
import { LanguageService } from "../../core/services/language.service";
import { UserModel } from "../../models/users/user.model";
import { DataService } from "../../core/services/data/data.service";
import { Utility } from "../../core/helpers/utility";
import { NotificationComponent } from "../../shared/ui/notification/notification.component";

@Component({
  selector: "app-topbar",
  templateUrl: "./topbar.component.html",
  styleUrls: [],
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    BsDropdownModule,
    SimplebarAngularModule,
    RouterLink,
    NgOptimizedImage,
    NotificationComponent,
  ],
})

/**
 * Topbar component
 */
export class TopbarComponent implements OnInit {
  mode: any;
  element: any;
  cookieValue: any;
  flagvalue: any;
  countryName: any;
  valueset: any;
  theme: any;
  layout: string;
  dataLayout$: Observable<string>;
  userData: any;
  userRole: any;

  // Define layoutMode as a property
  listLang: any = [
    {text: "English", flag: "assets/images/flags/us.jpg", lang: "en"},
    // { text: "Spanish", flag: "assets/images/flags/spain.jpg", lang: "es" },
    // { text: "German", flag: "assets/images/flags/germany.jpg", lang: "de" },
    // { text: "Italian", flag: "assets/images/flags/italy.jpg", lang: "it" },
    // { text: "Russian", flag: "assets/images/flags/russia.jpg", lang: "ru" },
  ];
  openMobileMenu: boolean;
  @Output() settingsButtonClicked = new EventEmitter();
  @Output() mobileMenuButtonClicked = new EventEmitter();
  showOnSuperAdmin: string[] = ["superadmin"];
  showOnAdmin: string[] = ["superadmin", "admin"];
  private utility: Utility;

  constructor(
    @Inject(DOCUMENT) private document: any,
    private router: Router,
    private authService: AuthenticationService,
    private dataService: DataService,
    public languageService: LanguageService,
    public translate: TranslateService,
    public _cookiesService: CookieService,
  ) {
    this.utility = new Utility();
  }

  ngOnInit() {
    // this.initialAppState = initialState;
    this.openMobileMenu = false;
    this.element = document.documentElement;

    this.cookieValue = this._cookiesService.get("lang");
    const val = this.listLang.filter((x) => x.lang === this.cookieValue);
    this.countryName = val.map((element) => element.text);
    if (val.length === 0) {
      if (this.flagvalue === undefined) {
        this.valueset = "assets/images/flags/us.jpg";
      }
    } else {
      this.flagvalue = val.map((element) => element.flag);
    }

    // Get User Data — use DataService so both localStorage ("remember me")
    // and sessionStorage (non-remember-me) logins are handled. Guard role[]
    // so accounts without a resolved role (or empty payload) do not crash.
    this.userData = this.dataService.getUserData() || {};
    this.userRole = this.userData?.role?.[0] || '';
    // console.log("userdata:", this.userData);
    // console.log("userRole:", this.userRole);
  }

  setLanguage(text: string, lang: string, flag: string) {
    this.countryName = text;
    this.flagvalue = flag;
    this.cookieValue = lang;
  }

  /**
   * Toggles the right sidebar
   */
  toggleRightSidebar() {
    this.settingsButtonClicked.emit();
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }

  /**
   * Logout the user
   */
  logout() {
    this.authService
      .userLogout()
      .then((success) => {
        if (success) {
          // Clear any stored tokens or user data
          this.router.navigate(["/auth/login2"]);
        } else {
          console.error("Logout failed");
        }
      })
      .catch((error) => {
        console.error("An error occurred during logout", error);
      });
  }

  /**
   * Fullscreen method
   */
  fullscreen() {
    document.body.classList.toggle("fullscreen-enable");
    if (
      !document.fullscreenElement &&
      !this.element.mozFullScreenElement &&
      !this.element.webkitFullscreenElement
    ) {
      if (this.element.requestFullscreen) {
        this.element.requestFullscreen();
      } else if (this.element.mozRequestFullScreen) {
        /* Firefox */
        this.element.mozRequestFullScreen();
      } else if (this.element.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.element.webkitRequestFullscreen();
      } else if (this.element.msRequestFullscreen) {
        /* IE/Edge */
        this.element.msRequestFullscreen();
      }
    } else {
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        /* Firefox */
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        /* IE/Edge */
        this.document.msExitFullscreen();
      }
    }
  }

  getProfileInitials(fullName: string): string {
    if (typeof fullName == 'undefined' || fullName == '') {
      return 'A';
    } else {
      const nameParts = fullName.split(' '); // Split the name by spaces
      const initials = nameParts.map(part => part.charAt(0).toUpperCase()); // Get the first letter of each part
      return initials.join(''); // Join them into a single string}
    }
  }

  /**
   * Using the Utility method to check user access
   */
  checkRoleAccess(roleList: string[]) {
    console.log(roleList);
    return this.utility.showFromRole(roleList?.length ? roleList : [], this.userRole);
  }
}
